import auth from "./auth"

const common = {
  getActionByRSI: (rsi) => {
    if (rsi <= 30) { return { action: 'BUY', alertClass: 'alert-buy', borderClass: 'border-buy' } }
    if (rsi > 30 && rsi <= 40) { return {action: 'CTB', alertClass: 'alert-close-to-buy', borderClass: 'border-close-to-buy' }}
    if (rsi > 40 && rsi < 60) { return {action: 'WAIT', alertClass: 'alert-wait', borderClass: 'border-wait' } }
    if (rsi >= 60 && rsi < 70) { return {action: 'CTS', alertClass: 'alert-close-to-sell', borderClass: 'border-close-to-sell' } }
    if (rsi >= 70) { return {action: 'SELL', alertClass: 'alert-sell', borderClass: 'border-sell' } }
    return {action: '---', alertClass: 'alert-wait', borderClass: 'border-wait' }
  },
  getColorByAction: (action) => {
    if (action === 'BUY') { return { alertClass: 'alert-buy' } }
    if (action === 'SELL') { return { alertClass: 'alert-sell' } }
    if (action === 'WAIT') { return { alertClass: 'border-wait' } }
  },
  getBorderByAction: (action) => {
    if (action === 'BUY') { return { borderClass: 'border-buy' } }
    if (action === 'SELL') { return { borderClass: 'border-sell' } }
    if (action === 'WAIT') { return { borderClass: 'border-wait' } }
  },
  getHeatmapColorByAction: (action) => {
    if (action === 'BUY') { return { color: '#137a01' } }
    if (action === 'SELL') { return { color: '#870c06' } }
    if (action === 'WAIT') { return { color: '#afafaf' } }
  },
  buyCount: (coins) => {
    return coins.filter(x => x.rsi <= 40).length
  },
  sellCount: (coins) => {
    return coins.filter(x => x.rsi >= 60).length
  },
  waitCount: (coins) => {
    return coins.filter(x => x.rsi > 40 && x.rsi < 60).length
  },
  hideForFree: (coin) => {
    return (coin.rank > 10) && !auth.isUnlocked()
  }
}

export default common;
